import logo from "../assets/logo.png";
import s1 from "../assets/s1.avif";
import s2 from "../assets/s2.avif";
import s3 from "../assets/s3.avif";
import s4 from "../assets/s4.png";
import pet from "../assets/pet.jpg";

function Footer() {
    return ( 
        <>
            <footer>
                <div className="footer-up">
                    <div className="container">
                        <center>
                            <div className="logo">
                                <img src={logo} alt="" />
                            </div>
                            <h2>
                                We will do everything to try to stop euthanasia before 2030
                            </h2>
                            <p>
                                Wolfpack Animals Foundation, a 501(c)(3) nonprofit organization, operates a sanctuary for homeless animals and provides adoption and educational programs.
                            </p>
                            <div className="star-row">
                                <img src={s1} alt="" />
                                <img src={s2} alt="" />
                                <img src={s3} alt="" />
                                <img src={s4} alt="" />
                            </div>
                        </center>

                        <div class="image-special-p">
                            <img alt="" src={pet} />
                            <p>Founder and CEO<br />Daniel Osterreich</p>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="footer-down">
                    <div className="container flex-box">
                        <div className="copyright">
                            © 2020 WPA Foundation | All rights reserved
                        </div>
                        <div className="copyright">
                            <a href="https://wolfpack-entertainment.net/">Wolfpack-entertainment.net</a>
                        </div>
                    </div>
                </div>
            </footer>
        </>
     );
}

export default Footer;